import axios from 'axios';
import { getBaseUrl } from 'utils/url';

export interface CreateCompanyRequest {
  name: string;
  domain?: string;
  industry?: string;
  numberOfEmployees?: string;
  city?: string;
  state?: string;
  country?: string;
  intentStrength?: string;
  confidenceScore?: number;
  partnerSources?: string;
  dataSource?: string;
  techOverlapCount?: number;
  intentSignalCount?: number;
}

export interface HubSpotCompany {
  id: string;
  properties: {
    name: string;
    domain?: string;
    industry?: string;
    [key: string]: string | undefined;
  };
  createdAt: string;
  updatedAt: string;
}

export interface CreateCompanyResponse {
  success: boolean;
  data: HubSpotCompany;
}

export interface HubSpotErrorResponse {
  success: false;
  error: {
    code: string;
    message: string;
  };
}

class HubSpotService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = getBaseUrl();
  }

  private getHeaders(token?: string) {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    return headers;
  }

  /**
   * Create a new company in HubSpot CRM
   */
  async createCompany(
    request: CreateCompanyRequest,
    token?: string,
  ): Promise<CreateCompanyResponse> {
    try {
      const response = await axios.post(
        `${this.baseUrl}/api/hubspot/companies`,
        request,
        { headers: this.getHeaders(token) },
      );
      return response.data;
    } catch (error: any) {
      console.error('Error creating company in HubSpot:', error);
      // Re-throw with more context if available
      if (error.response?.data?.error) {
        throw new Error(
          error.response.data.error.message || 'Failed to create company',
        );
      }
      throw error;
    }
  }
}

export const hubspotService = new HubSpotService();
